import axios from 'axios';
import React from 'react';
import moment from 'moment';
import { konamiApi } from '../../api';
import { fetchManagementTags } from '../../services/killshot';
import { searchQueryString, getOnSaleDate, fixColumnPresets, fixColumnOrder } from '../../helpers/event-search';
import EventProfitability from '../../components/EventSearch/EventProfitability';
import {
  SEARCH_RESULTS_HAS_ERRORED,
  SEARCH_RESULTS_IS_LOADING,
  FETCH_PRESET_FILTERS_IS_LOADING,
  SAVE_PRESET_FILTERS_IS_LOADING,
  UPDATE_PRESET_FILTERS_IS_LOADING,
  DELETE_PRESET_FILTERS_IS_LOADING,
  FETCH_COLUMN_PRESETS_IS_LOADING,
  COLUMN_PRESET_SAVE_IS_LOADING,
  SEARCH_RESULTS_FETCH_DATA_SUCCESS,
  PRESET_FILTERS_FETCH_DATA_SUCCESS,
  INVENTORY_TAG_FETCH_SUCCESS,
  COLUMN_PRESET_FETCH_DATA_SUCCESS,
  PRESET_FILTER_SAVE_SUCCESS,
  TOTAL_EVENTS_FETCH_SUCCESS,
  CURRENT_PAGE_FETCH_SUCCESS,
  HANDLE_LOAD_FILTERS,
  HANDLE_SAVE_FILTERS,
  SHOW_PRESET_FILTER_OP_BUTTON,
  SHOW_COLUMN_PRESET_OP_BUTTON,
  HANDLE_PRESET_FILTER_OP_SELECT_CHANGE,
  HANDLE_COLUMN_PRESET_OP_SELECT_CHANGE,
  PRESET_FILTER_UPDATE_BUTTON_ENABLED,
  PRESET_FILTER_DELETE_BUTTON_ENABLED,
  COLUMN_PRESET_LOAD_BUTTON_ENABLED,
  COLUMN_PRESET_DEFAULT_BUTTON_ENABLED,
  COLUMN_PRESET_SAVE_BUTTON_ENABLED,
  PRESET_FILTER_LOAD_BUTTON_ENABLED,
  PRESET_FILTER_OP_MODAL_LOADING,
  TRIGGER_UPDATE_FORM_VALUES,
  PRESET_FILTER_UPDATE_SUCCESS,
  PRESET_FILTER_DELETE_SUCCESS,
  SNACKBAR_IS_OPEN,
  SET_SNACKBAR_MESSAGE,
  CHANGE_CURRENT_PAGE,
  RELOAD_ALL_FILTERS,
  RELOAD_ALL_COLUMN_PRESETS,
  COLUMN_NAMES_CHANGE,
  HANDLE_LOAD_COLUMN_PRESETS,
  HANDLE_SAVE_COLUMN_PRESETS,
  HANDLE_DELETE_COLUMN_PRESETS,
  SET_COLUMN_PRESET_NAME,
  COLUMN_PRESET_LOAD_BUTTON_VISIBLE,
  COLUMN_PRESET_SAVE_BUTTON_VISIBLE,
  COLUMN_PRESET_LOAD_MODAL_LOADING,
  PULL_NOW_POST_IN_PROGRESS,
  HANDLE_SELECTION_CHANGE,
  SUB_GENRE_UPDATE_SUCCESS,
  HANDLE_EDIT_NOTIFICATIONS,
  HANDLE_TOGGLE_FILTERS,
  NOTIFICATION_SWITCH_ACTIVE,
  COLUMN_ORDER_CHANGE,
  COLUMN_WIDTH_CHANGE,
  COLUMN_PINNED_CHANGE,
  LIMITSHEET_IS_LOADING,
  LIMITSHEET_URL,
  LIMITSHEET_SUCCESS_OPEN,
  WHOS_NAME_CHANGE,
  LIMITSHEET_TITLE,
  INFO_SNACKBAR_OPEN,
  EVENT_SEARCH_ROW_SELECTED,
  SHOW_SAVE_COLUMNS_BUTTON,
  SHOW_SAVE_FILTERS_BUTTON,
  EVENT_TAGS_FETCH_SUCCESS,
} from '../constants/event-search';
import { defaultColumnWidths } from '../../constants/event-search';
import { convertDateWithTimezone, arrayToQueryString } from '../../pages/EventSearch/utils';

const CURRENT_CONTEXT = 'Redux Event Search Action -> ';

const OK = 'ok';
// eslint-disable-next-line no-console
const Log = console;

export const searchResultsHasErrored = bool => ({ type: SEARCH_RESULTS_HAS_ERRORED, hasErrored: bool });

export const infoSnackbarIsOpen = bool => ({ type: INFO_SNACKBAR_OPEN, snackbarOpen: bool });

export const searchResultsIsLoading = bool => ({ type: SEARCH_RESULTS_IS_LOADING, isLoading: bool });

export const limitsheetIsLoading = bool => ({ type: LIMITSHEET_IS_LOADING, limitSheetsLoading: bool });

export const fetchPresetFiltersIsLoading = bool => ({
  type: FETCH_PRESET_FILTERS_IS_LOADING,
  presetFiltersIsLoading: bool,
});

export const fetchColumnPresetsIsLoading = bool => ({
  type: FETCH_COLUMN_PRESETS_IS_LOADING,
  columnPresetsIsLoading: bool,
});

export const savePresetFiltersIsLoading = bool => ({
  type: SAVE_PRESET_FILTERS_IS_LOADING,
  savePresetFiltersIsLoading: bool,
});

export const columnPresetSaveIsLoading = bool => ({
  type: COLUMN_PRESET_SAVE_IS_LOADING,
  columnPresetSaveIsLoading: bool,
});

export const updatePresetFiltersIsLoading = bool => ({
  type: UPDATE_PRESET_FILTERS_IS_LOADING,
  updatePresetFiltersIsLoading: bool,
});

export const deletePresetFiltersIsLoading = bool => ({
  type: DELETE_PRESET_FILTERS_IS_LOADING,
  deletePresetFiltersIsLoading: bool,
});

export const searchResultsFetchSuccess = searchResults => ({ type: SEARCH_RESULTS_FETCH_DATA_SUCCESS, searchResults });

export const presetFiltersFetchSuccess = presetFilters => ({ type: PRESET_FILTERS_FETCH_DATA_SUCCESS, presetFilters });

export const inventoryTagsSuccess = inventoryTags => ({ type: INVENTORY_TAG_FETCH_SUCCESS, inventoryTags });

export const eventTagsSuccess = eventTags => ({ type: EVENT_TAGS_FETCH_SUCCESS, eventTags });

export const updateSubGenreSuccess = subGenres => ({ type: SUB_GENRE_UPDATE_SUCCESS, subGenres });

export const columnPresetFetchSuccess = savedColumnPresets => ({
  type: COLUMN_PRESET_FETCH_DATA_SUCCESS,
  savedColumnPresets,
});

export const presetFilterSaveSuccess = bool => ({ type: PRESET_FILTER_SAVE_SUCCESS, presetFilterSaveSuccess: bool });

export const totalEventsFetchSuccess = totalEvents => ({ type: TOTAL_EVENTS_FETCH_SUCCESS, totalEvents });

export const currentPageFetchSuccess = currentPage => ({ type: CURRENT_PAGE_FETCH_SUCCESS, currentPage });

export const limsheetUrl = sheetUrl => ({ type: LIMITSHEET_URL, sheetUrl });

export const limsheetTitle = sheetName => ({ type: LIMITSHEET_TITLE, sheetName });

export const showPresetFilterOpButton = bool => ({
  type: SHOW_PRESET_FILTER_OP_BUTTON,
  presetFilterLoadButtonVisible: bool,
});

export const showColumnPresetOpButton = bool => ({
  type: SHOW_COLUMN_PRESET_OP_BUTTON,
  columnPresetLoadButtonVisible: bool,
});

export const showSaveFiltersButton = bool => ({
  type: SHOW_SAVE_FILTERS_BUTTON,
  presetFilterSaveButtonVisible: bool,
});

export const showSaveColumnsButton = bool => ({
  type: SHOW_SAVE_COLUMNS_BUTTON,
  showSaveColumnsButton: bool,
});

export const handleLoadFilters = bool => ({ type: HANDLE_LOAD_FILTERS, presetFilterLoadModalOpen: bool });

export const handleSaveFilters = bool => ({ type: HANDLE_SAVE_FILTERS, presetFilterSaveModalOpen: bool });

export const handleLoadColumnPresets = bool => ({ type: HANDLE_LOAD_COLUMN_PRESETS, columnPresetLoadModalOpen: bool });

export const handleSaveColumnPresets = bool => ({ type: HANDLE_SAVE_COLUMN_PRESETS, columnPresetSaveModalOpen: bool });

export const handleEditNotifications = bool => ({
  type: HANDLE_EDIT_NOTIFICATIONS,
  notificationPresetSaveModalOpen: bool,
});

export const handleDeleteColumnPresets = bool => ({
  type: HANDLE_DELETE_COLUMN_PRESETS,
  columnPresetDeleteModalOpen: bool,
});

export const presetFilterUpdateButtonEnabled = bool => ({
  type: PRESET_FILTER_UPDATE_BUTTON_ENABLED,
  presetFilterUpdateButtonEnabled: bool,
});

export const presetFilterDeleteButtonEnabled = bool => ({
  type: PRESET_FILTER_DELETE_BUTTON_ENABLED,
  presetFilterDeleteButtonEnabled: bool,
});

export const presetFilterLoadButtonEnabled = bool => ({
  type: PRESET_FILTER_LOAD_BUTTON_ENABLED,
  presetFilterLoadButtonEnabled: bool,
});

export const columnPresetLoadButtonEnabledAction = bool => ({
  type: COLUMN_PRESET_LOAD_BUTTON_ENABLED,
  columnPresetLoadButtonEnabled: bool,
});

export const columnPresetDefaultButtonEnabledAction = bool => ({
  type: COLUMN_PRESET_DEFAULT_BUTTON_ENABLED,
  columnPresetDefaultButtonEnabled: bool,
});

export const columnPresetSaveButtonEnabledAction = bool => ({
  type: COLUMN_PRESET_SAVE_BUTTON_ENABLED,
  columnPresetSaveButtonEnabled: bool,
});

export const presetFilterOpModalLoading = bool => ({
  type: PRESET_FILTER_OP_MODAL_LOADING,
  presetFilterOpModalLoading: bool,
});

export const columnPresetLoadModalLoading = bool => ({
  type: COLUMN_PRESET_LOAD_MODAL_LOADING,
  presetFilterLoadModalLoading: bool,
});

export const triggerUpdateFormValues = bool => ({ type: TRIGGER_UPDATE_FORM_VALUES, updateFormValues: bool });

export const presetFilterUpdateSuccess = bool => ({
  type: PRESET_FILTER_UPDATE_SUCCESS,
  presetFilterUpdateSuccess: bool,
});

export const presetFilterDeleteSuccess = bool => ({
  type: PRESET_FILTER_DELETE_SUCCESS,
  presetFilterDeleteSuccess: bool,
});

export const setColumnPresetName = name => ({
  type: SET_COLUMN_PRESET_NAME,
  columnPresetName: name,
});

export const snackbarIsOpen = bool => ({ type: SNACKBAR_IS_OPEN, snackbarIsOpen: bool });

export const setSnackbarMessage = snackbarMessage => ({ type: SET_SNACKBAR_MESSAGE, snackbarMessage });

export const changeCurrentPage = currentPage => ({ type: CHANGE_CURRENT_PAGE, currentPage });

export const reloadAllFilters = bool => ({ type: RELOAD_ALL_FILTERS, reloadAllFilters: bool });

export const reloadAllColumnPresets = bool => ({ type: RELOAD_ALL_COLUMN_PRESETS, reloadAllColumnPresets: bool });

export const hiddenColumnNamesChange = columnPresets => ({ type: COLUMN_NAMES_CHANGE, columnPresets });

export const columnOrderChange = columnOrder => ({ type: COLUMN_ORDER_CHANGE, columnOrder });

export const columnWidthChange = columnWidths => ({ type: COLUMN_WIDTH_CHANGE, columnWidths });

export const pinnedColumns = leftColumns => ({ type: COLUMN_PINNED_CHANGE, leftColumns });

export const whosNameLimsheets = whosNames => ({ type: WHOS_NAME_CHANGE, whosNames });

export const columnPresetLoadButtonVisible = bool => ({
  type: COLUMN_PRESET_LOAD_BUTTON_VISIBLE,
  columnPresetLoadButtonVisible: bool,
});

export const columnPresetSaveButtonVisible = bool => ({
  type: COLUMN_PRESET_SAVE_BUTTON_VISIBLE,
  columnPresetSaveButtonVisible: bool,
});

export const handlePresetFilterOpSelectChange = selectedPreset => ({
  type: HANDLE_PRESET_FILTER_OP_SELECT_CHANGE,
  selectedPreset,
});

export const handleColumnPresetOpSelectChange = selectedColumnPreset => ({
  type: HANDLE_COLUMN_PRESET_OP_SELECT_CHANGE,
  selectedColumnPreset,
});

export const handlePullNowPostInProgress = bool => ({
  type: PULL_NOW_POST_IN_PROGRESS,
  pullNowPostInProgress: bool,
});

export const handleSelectionChange = events => ({
  type: HANDLE_SELECTION_CHANGE,
  selectedEvents: events,
  numSelectedEvents: events.length,
});

export const handleToggleFilters = bool => ({
  type: HANDLE_TOGGLE_FILTERS,
  filtersOpen: bool,
});

export const notificationSwitchActive = bool => ({
  type: NOTIFICATION_SWITCH_ACTIVE,
  notificationSwitchActive: bool,
});

export const limsheetSuccessOpen = bool => ({
  type: LIMITSHEET_SUCCESS_OPEN,
  openSuccessSnackBar: bool,
});

/** MIDDLEWARES */

export const handleChangePinnedColumns = (event, dispatch) => {
  Log.info('Redux Action -> changed column pinnin', event.target.value);
  dispatch(pinnedColumns(event));
};

export const handleToggleFiltersMiddleware = () => (dispatch, getState) => {
  const { filtersOpen } = getState().eventSearch;
  Log.info('Redux Action -> handleToggleFiltersMiddleware (filtersOpen)', filtersOpen);
  dispatch(handleToggleFilters(!filtersOpen));
};

export const pullSelectedEvents = () => (dispatch, getState) => {
  const { selectedEvents } = getState().eventSearch;
  Log.info('Redux Action -> handlePullNowClicked (selectedEvents)', selectedEvents);
  dispatch(handlePullNowPostInProgress(true));

  axios.all(selectedEvents.map(event => konamiApi.post(`event/pull/${event.event_id}`))).then(responses => {
    responses.forEach(response => {
      Log.info(response);
    });
    dispatch(handlePullNowPostInProgress(false));
  });
};

export const checkSelectedEvents = () => (dispatch, getState) => {
  const { selectedEvents } = getState().eventSearch;
  Log.info('Redux Action -> handlePullNowClicked (selectedEvents)', selectedEvents);
  dispatch(handlePullNowPostInProgress(true));

  axios
    .all(
      selectedEvents.map(event =>
        konamiApi.post(`user/ext_event_attr/${event.event_id}`, {
          checked_time: moment.utc(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        })
      )
    )
    .then(responses => {
      responses.forEach(response => {
        Log.info(response);
      });
      dispatch(handlePullNowPostInProgress(false));
    });
};

export const presetFilterLoadSubmitClicked = () => (dispatch, getState) => {
  const { presetFilters, selectedPreset } = getState().eventSearch;
  Log.info('Redux Action -> presetFilterLoadSubmitClicked (presetFilters)', presetFilters);
  Log.info('Redux Action -> presetFilterLoadSubmitClicked (selectedPreset)', selectedPreset);
  dispatch(presetFilterOpModalLoading(true));
  dispatch(triggerUpdateFormValues(true));
  Log.info('Redux Action -> presetFilterLoadSubmitClicked (finished)', true);
};

export const columnPresetLoadSubmitClicked = tableRef => (dispatch, getState) => {
  const { savedColumnPresets, selectedColumnPreset, columnWidths } = getState().eventSearch;
  Log.info('Redux Action -> columnPresetLoadSubmitClicked (savedColumnPresets)', savedColumnPresets);
  Log.info('Redux Action -> columnPresetLoadSubmitClicked (selectedColumnPreset)', selectedColumnPreset);
  const { columnOrder } = getState().eventSearch;
  const filtersTreated = fixColumnPresets(savedColumnPresets, columnOrder, columnWidths);
  const currColumnPresetTreated = filtersTreated.find(o => o.id === selectedColumnPreset);
  const currColumnPreset = savedColumnPresets.find(o => o.id === selectedColumnPreset);
  dispatch(columnPresetLoadModalLoading(true));
  dispatch(hiddenColumnNamesChange(currColumnPreset.value[0]));
  const fixedColumnOrder = fixColumnOrder(currColumnPreset.value[1], columnOrder);
  Log.info('Redux Action -> fixColumnOrder (fixColumnOrder)', fixedColumnOrder);
  dispatch(columnOrderChange(fixedColumnOrder));
  Log.info('Redux Action -> adjustedWidths (adjustedWidths)', currColumnPreset.value[2]);
  dispatch(columnWidthChange(currColumnPresetTreated.value[2]));
  Log.info('Redux Action -> columnOrder', currColumnPreset.value[1]);
  Log.info('Redux Action -> columnPresetLoadSubmitClicked (selectedColumnPreset)', currColumnPreset.value[3]);
  dispatch(pinnedColumns(Array.isArray(currColumnPreset.value[3]) ? currColumnPreset.value[3] : []));
  dispatch(handleLoadColumnPresets(false));
  Log.info('Redux Action -> columnPresetLoadSubmitClicked (finished)', true);

  if (tableRef?.columnApi) {
    const { columnApi } = tableRef;
    columnApi.moveColumns(fixedColumnOrder);
    if (currColumnPreset.value[0].length) {
      columnApi.hideColumns(currColumnPreset.value[0], true);
    }

    if (Array.isArray(currColumnPreset.value[3]) && currColumnPreset.value[3].length) {
      columnApi.setColumnsPinned(currColumnPreset.value[3], 'left');
    }
  }
};

export const fetchPresetFilters = () => dispatch => {
  dispatch(fetchPresetFiltersIsLoading(true));
  konamiApi
    .get(`${process.env.USER_API_URI}sets/1/keys`)
    .then(res => {
      Log.info('Redux Action -> fetchPresetFilters (success)', res);
      const presetFilters = res.filters.map(filter => ({
        id: filter.id,
        description: filter.description,
        value: filter.value,
      }));
      dispatch(presetFiltersFetchSuccess(presetFilters));
      dispatch(fetchPresetFiltersIsLoading(false));
      if (res.status === OK && res.filters) {
        Log.info('Redux Action -> fetchPresetFilters (status OK and keys fetched)', res.filters);
        dispatch(showPresetFilterOpButton(true));
        dispatch(reloadAllFilters(false));
      } else {
        Log.info('Redux Action -> fetchPresetFilters (status not OK or keys object empty', true);
        alert('Error when fetching preset filters from server.');
        dispatch(reloadAllFilters(false));
        throw new Error();
      }
    })
    .catch(err => {
      Log.info('Redux Action -> fetchPresetFilters (error)', err);
      dispatch(fetchPresetFiltersIsLoading(false));
      dispatch(reloadAllFilters(false));
    });
};

export const fetchInventoryTags = () => dispatch => {
  konamiApi
    .get(`tags/?table=line`)
    .then(response => {
      dispatch(inventoryTagsSuccess([...new Set(response.tags)]));
    })
    .catch(err => {
      Log.info('Redux Action -> fetchInventoryTags (error)', err);
    });
};

/* fetchEventTags Fetch event tags to filter
 */
export const fetchEventTags = () => async dispatch => {
  const response = await fetchManagementTags();
  dispatch(eventTagsSuccess(response));
};

export const updateSubGenres = (_, eventValue) => dispatch => {
  Log.info('Redux Action -> updateSubGenres (eventValue)', eventValue);
  const apiURI = eventValue.length ? `?genre=${eventValue}` : '';
  konamiApi
    .get(process.env.GENRE_API_URI + apiURI)
    .then(response => {
      Log.info('Redux Action -> updateSubGenres (success response)', response);
      dispatch(updateSubGenreSuccess(response.genres));
    })
    .catch(err => {
      Log.info('Redux Action -> updateSubGenres (error message)', err.message);
    });
};

export const savePresetFilters = (_, filters, presetFilterName) => dispatch => {
  Log.info('Redux Action -> savePresetFilters (filters)', filters);
  Log.info('Redux Action -> savePresetFilters (presetFilterName)', presetFilterName);
  dispatch(savePresetFiltersIsLoading(true));
  konamiApi
    .post(`${process.env.USER_API_URI}sets/1/keys`, {
      description: presetFilterName,
      value: filters,
    })
    .then(res => {
      dispatch(savePresetFiltersIsLoading(false));
      dispatch(handleSaveFilters(false));
      dispatch(fetchPresetFilters());
      Log.info('Redux Action -> savePresetFilters (success)', res);
    })
    .catch(err => {
      dispatch(savePresetFiltersIsLoading(false));
      dispatch(presetFilterSaveSuccess(false));
      Log.info('Redux Action -> savePresetFilters (error)', err);
      alert('Error in saving preset filters server request.');
    });
};

export const notifyFilter = (_, id, isChecked) => (dispatch, getState) => {
  // TODO: only pass `notify` value instead of entire filter set
  const { selectedPreset } = getState().eventSearch;
  Log.info('Redux Action -> updatePresetFilters (selectedPreset)', selectedPreset);
  dispatch(updatePresetFiltersIsLoading(true));
  konamiApi
    .put(`${process.env.USER_API_URI}keys/${id}`, {
      value: { notify: isChecked },
      mode: 'update',
    })
    .then(res => {
      dispatch(updatePresetFiltersIsLoading(false));
      dispatch(presetFilterUpdateSuccess(true));
      dispatch(fetchPresetFilters());
      Log.info('Redux Action -> updatePresetFilters (res)', res);
    })
    .catch(err => {
      dispatch(updatePresetFiltersIsLoading(false));
      dispatch(presetFilterUpdateSuccess(false));
      Log.info('Redux Action -> updatePresetFilters (err)', err);
      alert('Error when saving nofication filter preference.');
    });
};

export const updatePresetFilters = (_, filters, id) => (dispatch, getState) => {
  const { selectedPreset } = getState().eventSearch;
  Log.info('Redux Action -> updatePresetFilters (selectedPreset)', selectedPreset);
  Log.info('Redux Action -> updatePresetFilters (filters)', filters);

  dispatch(updatePresetFiltersIsLoading(true));
  konamiApi
    .put(`${process.env.USER_API_URI}keys/${id}`, { value: filters })
    .then(res => {
      dispatch(updatePresetFiltersIsLoading(false));
      dispatch(presetFilterUpdateSuccess(true));
      dispatch(fetchPresetFilters());
      dispatch(handleLoadFilters(false));
      Log.info('Redux Action -> updatePresetFilters (res)', res);
    })
    .catch(err => {
      dispatch(updatePresetFiltersIsLoading(false));
      dispatch(presetFilterUpdateSuccess(false));
      Log.info('Redux Action -> updatePresetFilters (err)', err);
      alert('Error in update preset filters server request.');
    });
};

export const deletePresetFilters = (_, id) => dispatch => {
  Log.info('Redux Action -> deletePresetFilters (selectedPreset)', id);
  dispatch(deletePresetFiltersIsLoading(true));
  konamiApi
    .delete(`${process.env.USER_API_URI}keys/${id}`)
    .then(res => {
      dispatch(deletePresetFiltersIsLoading(false));
      dispatch(presetFilterDeleteSuccess(true));
      Log.info('Redux Action -> deletePresetFilters (res)', res);
      dispatch(fetchPresetFilters());
    })
    .catch(err => {
      dispatch(deletePresetFiltersIsLoading(false));
      dispatch(presetFilterDeleteSuccess(false));
      alert('Error in delete preset filters server request.');
      Log.info('Redux Action -> deletePresetFilters (err)', err);
    });
};

export const fetchSearchResults = (classes, _, formValues, sorting) => (dispatch, getState) => {
  const { currentPage } = getState().eventSearch;
  let finalFormValues = { ...formValues, page: currentPage };
  Log.info('Redux Action -> fetchSearchResults (currentPage)', currentPage);
  dispatch(searchResultsIsLoading(true));

  const { formVals, arrValues } = Object.keys(finalFormValues).reduce(
    (acc, key) => {
      if (finalFormValues[key] instanceof Array) {
        acc.arrValues[key] = finalFormValues[key];
      } else {
        acc.formVals[key] = finalFormValues[key];
      }
      return acc;
    },
    { arrValues: {}, formVals: {} }
  );

  const queryString = arrayToQueryString(arrValues);

  finalFormValues = formVals;

  if (sorting.columnName) {
    finalFormValues = {
      ...finalFormValues,
      sort_column: sorting.columnName,
      sort_order: sorting.direction,
    };
  }

  konamiApi
    .get(`${process.env.SEARCH_API_URI}?${queryString}`, { params: finalFormValues })
    .then(res => {
      const searchObject = res.events.map(event => {
        Log.info('Redux Actions -> fetchSearchResults', event);
        /** @namespace event.venue * */
        /** @namespace event.profitability * */
        /** @namespace event.venue.timezone * */
        /** @namespace event.venue.max_capacity * */
        /** @namespace event.on_sale * */
        /** @namespace event.tm_stats * */
        /** @namespace event.tm_stats.percent_av * */
        /** @namespace event.tm_stats.event_capacity * */
        /** @namespace event.tm_stats.total_primary_tickets_av * */
        /** @namespace event.tm_stats.total_secondary_tickets_av * */
        /** @namespace event.tm_stats.pace * */
        /** @namespace event.tm_stats.tm_min_face * */
        /** @namespace event.tm_stats.tm_min_total * */
        /** @namespace event.sh_stats.tickets_av * */
        /** @namespace event.sh_stats.sales_24hr * */
        /** @namespace event.sh_stats.min_price * */
        /** @namespace event.sh_stats.total_sales * */
        /** @namespace event.sh_stats.three_ma * */
        /** @namespace event.sh_stats.seven_ma * */
        /** @namespace event.sh_stats.three_sales_ma * */
        /** @namespace event.sh_stats.seven_sales_ma * */
        /** @namespace event.sh_stats.num_viewing * */
        /** @namespace event.sb_stats.seven_day_num_sold * */
        /** @namespace event.sb_stats.total_num_sold * */
        /** @namespace event.sb_stats.total_num_held * */
        /** @namespace event.sb_stats.thirty_day_num_sold * */
        /** @namespace event.sb_stats.total_num_purchased * */
        /** @namespace event.sb_stats.last_invoice_date * */
        /** @namespace event.sb_stats.sb_pace * */
        return {
          sh_calc: event.sh_stats.gmt_calc_time,
          sb_calc: event.sb_stats.gmt_calc_time,
          tm_calc: event.tm_stats.gmt_calc_time,
          event_id: event.id,
          event_name: event.name,
          event_profitability: event.profitability,
          inventory_tags: event.sb_stats.inventory_tags,
          event_links: event.links,
          skybox_sales_link: event.skybox_sales_link,
          reps_links: event.reps_links,
          event_date: convertDateWithTimezone(event.event_date, event?.venue?.timezone, 'MM/DD/YYYY hh:mm A ddd'),
          event_date_local: event.event_date_local,
          day_of_week: event.day_of_week,
          onsale_date: getOnSaleDate(
            event.links,
            event.on_sale_local,
            convertDateWithTimezone(event.on_sale_local, event?.venue?.timezone, 'MM/DD/YYYY hh:mm A ddd'),
            event.id,
            classes
          ),
          onsale_local: event.on_sale_local || event.event_onsale_local,
          checked_date: event.checked_date,
          days_since_last_checked: event.days_until_checked_time,
          event_genre: event.genre.genre,
          performer: event.performer,
          emoji: event.user_props.emoji,
          venue_name: event.venue.name,
          venue_city: event.venue.city,
          venue_state: event.venue.state,
          venue_type: event.venue.type,
          days_until_event: event.days_until_event,
          days_since_last_sale: event.sb_stats.days_since_last_sale,
          days_since_last_purchase: event.sb_stats.days_since_last_purchase,
          venue_capacity: event.venue.max_capacity,
          primary_percent_av: event.tm_stats.percent_av,
          primary_qnt_3day: event.tm_stats['3_day_ma'],
          primary_qnt_7day: event.tm_stats['7_day_ma'],
          primary_qnt_30day: event.tm_stats['30_day_ma'],
          primary_event_capacity: event.tm_stats.event_capacity,
          primary_tix_av: event.tm_stats.total_primary_tickets_av,
          secondary_tix_av: event.tm_stats.total_secondary_tickets_av,
          one_day_primary_pace: event.tm_stats.one_day_tm_pace,
          three_day_primary_pace: event.tm_stats.pace,
          seven_day_primary_pace: event.tm_stats.seven_day_tm_pace,
          thirty_day_primary_pace: event.tm_stats.thirty_day_tm_pace,
          primary_min_price_face: event.tm_stats.tm_min_face,
          primary_min_price_total: event.tm_stats.tm_min_total,
          primary_tickets_cost: event.tm_stats.primary_tickets_cost,
          cloakedness: event.tm_stats.cloakedness,
          sh_tickets_av: event.sh_stats.tickets_av,
          sh_total_sales: event.sh_stats.total_sales,
          sh_3ma: event.sh_stats.three_ma,
          sh_7ma: event.sh_stats.seven_ma,
          sh_sales_3ma: event.sh_stats.three_sales_ma,
          sh_sales_7ma: event.sh_stats.seven_sales_ma,
          sh_sales_24hr: event.sh_stats.sales_24hr,
          sh_min_price: event.sh_stats.min_price,
          sh_1_day_min_price_ma: event.sh_stats['1_day_min_price_ma'],
          sh_3_day_min_price_ma: event.sh_stats['3_day_min_price_ma'],
          sh_7_day_min_price_ma: event.sh_stats['7_day_min_price_ma'],
          sh_30_day_min_price_ma: event.sh_stats['30_day_min_price_ma'],
          sh_num_viewing: event.sh_stats.num_viewing,
          sb_total_num_purchased: event.sb_stats.total_num_purchased,
          sb_total_num_held: event.sb_stats.total_num_held,
          sb_total_num_sold: event.sb_stats.total_num_sold,
          sb_thirty_day_num_sold: event.sb_stats.thirty_day_num_sold,
          sb_seven_day_num_sold: event.sb_stats.seven_day_num_sold,
          sb_last_invoice_date: moment(event.sb_stats.last_invoice_date_local).format('MM/DD/YYYY hh:mm A ddd'),
          sb_pace: event.sb_stats.sb_pace,
          sb_thirty_day_pace: event.sb_stats.sb_thirty_day_pace,
          sb_one_day_pace: event.sb_stats.sb_one_day_pace,
          sb_three_day_pace: event.sb_stats.sb_three_day_pace,
          sb_total_margin: event.sb_stats.sb_total_margin,
          sb_thirty_day_margin: event.sb_stats.sb_thirty_day_margin,
          sb_seven_day_margin: event.sb_stats.sb_seven_day_margin,
          sb_today_margin: event.sb_stats.sb_today_margin,
          sb_today_num_sold: event.sb_stats.today_num_sold,
          total_cost_of_tickets_held: event.sb_stats.total_cost,
          tickets_needed_to_sell_per_hour: event.sb_stats.tickets_needed_to_sell_per_hour,
          tickets_needed_to_sell_per_day: event.sb_stats.tickets_needed_to_sell_per_day,
          checked_time: event.checked_time,
          event_tags: event.event_tags,
          mrclean_links: [
            { link: `https://mrclean.reps2.com/tools/primary/${event.id}`, label: 'P' },
            { link: `https://mrclean.reps2.com/tools/secondary/${event.id}`, label: 'S' },
            { link: `https://mrclean.reps2.com/tools/venue/props/${event.venue.id}`, label: 'VP' },
            { link: `https://mrclean.reps2.com/tools/venue/map/${event.venue.id}`, label: 'VM' },
          ],
          hedge_fund_name: event.sb_stats.hedge_fund_info || 'None',
        };
      });
      Log.info('Redux Action -> fetchSearchResults (searchObject)', searchObject);
      dispatch(currentPageFetchSuccess(res.page));
      dispatch(totalEventsFetchSuccess(res.total_events));
      dispatch(searchResultsFetchSuccess(searchObject));
      dispatch(searchResultsIsLoading(false));
    })
    .catch(err => {
      Log.info('Redux Actions -> fetchSearchResults (error)', err);
      dispatch(searchResultsHasErrored(true));
      dispatch(searchResultsIsLoading(false));
      alert('Error when fetching search results from server.');
    });
};

/* Fetch for each event data for the ag grid
 * @param {array} events
 * @param {number} page
 */
export const fetchSearchResults2 = (page, sortModel, classes, formValues) => () => {
  Log.info(`${CURRENT_CONTEXT}fetchEventMeta`, true);
  const searchString = searchQueryString(page, formValues, sortModel);
  return konamiApi.get(process.env.SEARCH_API_URI + searchString).then(response => {
    const searchObject = response.events.map(event => {
      Log.info('Redux Actions -> fetchSearchResults', event);
      /** @namespace event.venue * */
      /** @namespace event.profitability * */
      /** @namespace event.venue.timezone * */
      /** @namespace event.venue.max_capacity * */
      /** @namespace event.on_sale * */
      /** @namespace event.tm_stats * */
      /** @namespace event.tm_stats.percent_av * */
      /** @namespace event.tm_stats.event_capacity * */
      /** @namespace event.tm_stats.total_primary_tickets_av * */
      /** @namespace event.tm_stats.total_secondary_tickets_av * */
      /** @namespace event.tm_stats.pace * */
      /** @namespace event.tm_stats.tm_min_face * */
      /** @namespace event.tm_stats.tm_min_total * */
      /** @namespace event.sh_stats.tickets_av * */
      /** @namespace event.sh_stats.sales_24hr * */
      /** @namespace event.sh_stats.min_price * */
      /** @namespace event.sh_stats.total_sales * */
      /** @namespace event.sh_stats.three_ma * */
      /** @namespace event.sh_stats.seven_ma * */
      /** @namespace event.sh_stats.three_sales_ma * */
      /** @namespace event.sh_stats.seven_sales_ma * */
      /** @namespace event.sh_stats.num_viewing * */
      /** @namespace event.sb_stats.seven_day_num_sold * */
      /** @namespace event.sb_stats.total_num_sold * */
      /** @namespace event.sb_stats.total_num_held * */
      /** @namespace event.sb_stats.thirty_day_num_sold * */
      /** @namespace event.sb_stats.total_num_purchased * */
      /** @namespace event.sb_stats.last_invoice_date * */
      /** @namespace event.sb_stats.sb_pace * */
      return {
        sh_calc: event.sh_stats.gmt_calc_time,
        sb_calc: event.sb_stats.gmt_calc_time,
        tm_calc: event.tm_stats.gmt_calc_time,
        event_id: event.id,
        event_name: <EventProfitability profit={event.profitability} eventName={event.name} />,
        inventory_tags: event.sb_stats.inventory_tags,
        event_links: event.links,
        skybox_sales_link: event.skybox_sales_link,
        reps_links: event.reps_links,
        event_date: moment(event.event_date_local).format('MM/DD/YYYY hh:mm A ddd'),
        event_date_local: event.event_date_local,
        day_of_week: event.day_of_week,
        onsale_date: getOnSaleDate(
          event.links,
          event.on_sale_local,
          moment(event.on_sale_local).format('MM/DD/YYYY hh:mm A ddd'),
          event.id,
          classes
        ),
        onsale_local: event.on_sale_local || event.event_onsale_local,
        checked_date: event.checked_date,
        days_since_last_checked: event.days_until_checked_time,
        event_genre: event.genre.genre,
        performer: event.performer,
        emoji: event.user_props.emoji,
        venue_name: event.venue.name,
        venue_city: event.venue.city,
        venue_state: event.venue.state,
        venue_type: event.venue.type,
        days_until_event: event.days_until_event,
        days_since_last_sale: event.sb_stats.days_since_last_sale,
        days_since_last_purchase: event.sb_stats.days_since_last_purchase,
        venue_capacity: event.venue.max_capacity,
        primary_percent_av: event.tm_stats.percent_av,
        primary_qnt_3day: event.tm_stats['3_day_ma'],
        primary_qnt_7day: event.tm_stats['7_day_ma'],
        primary_qnt_30day: event.tm_stats['30_day_ma'],
        primary_event_capacity: event.tm_stats.event_capacity,
        primary_tix_av: event.tm_stats.total_primary_tickets_av,
        secondary_tix_av: event.tm_stats.total_secondary_tickets_av,
        one_day_primary_pace: event.tm_stats.one_day_tm_pace,
        three_day_primary_pace: event.tm_stats.pace,
        seven_day_primary_pace: event.tm_stats.seven_day_tm_pace,
        thirty_day_primary_pace: event.tm_stats.thirty_day_tm_pace,
        primary_min_price_face: event.tm_stats.tm_min_face,
        primary_min_price_total: event.tm_stats.tm_min_total,
        primary_tickets_cost: event.tm_stats.primary_tickets_cost,
        cloakedness: event.tm_stats.cloakedness,
        sh_tickets_av: event.sh_stats.tickets_av,
        sh_total_sales: event.sh_stats.total_sales,
        sh_3ma: event.sh_stats.three_ma,
        sh_7ma: event.sh_stats.seven_ma,
        sh_sales_3ma: event.sh_stats.three_sales_ma,
        sh_sales_7ma: event.sh_stats.seven_sales_ma,
        sh_sales_24hr: event.sh_stats.sales_24hr,
        sh_min_price: event.sh_stats.min_price,
        sh_1_day_min_price_ma: event.sh_stats['1_day_min_price_ma'],
        sh_3_day_min_price_ma: event.sh_stats['3_day_min_price_ma'],
        sh_7_day_min_price_ma: event.sh_stats['7_day_min_price_ma'],
        sh_30_day_min_price_ma: event.sh_stats['30_day_min_price_ma'],
        sh_num_viewing: event.sh_stats.num_viewing,
        sb_total_num_purchased: event.sb_stats.total_num_purchased,
        sb_total_num_held: event.sb_stats.total_num_held,
        sb_total_num_sold: event.sb_stats.total_num_sold,
        sb_thirty_day_num_sold: event.sb_stats.thirty_day_num_sold,
        sb_seven_day_num_sold: event.sb_stats.seven_day_num_sold,
        sb_last_invoice_date: moment(event.sb_stats.last_invoice_date_local).format('MM/DD/YYYY hh:mm A ddd'),
        sb_pace: event.sb_stats.sb_pace,
        sb_thirty_day_pace: event.sb_stats.sb_thirty_day_pace,
        sb_one_day_pace: event.sb_stats.sb_one_day_pace,
        sb_three_day_pace: event.sb_stats.sb_three_day_pace,
        sb_total_margin: event.sb_stats.sb_total_margin,
        sb_thirty_day_margin: event.sb_stats.sb_thirty_day_margin,
        sb_seven_day_margin: event.sb_stats.sb_seven_day_margin,
        sb_today_margin: event.sb_stats.sb_today_margin,
        sb_today_num_sold: event.sb_stats.today_num_sold,
        total_cost_of_tickets_held: event.sb_stats.total_cost,
        tickets_needed_to_sell_per_hour: event.sb_stats.tickets_needed_to_sell_per_hour,
        tickets_needed_to_sell_per_day: event.sb_stats.tickets_needed_to_sell_per_day,
        checked_time: event.checked_time,
        event_tags: event.event_tags,
        mrclean_links: [
          <a
            href={`https://mrclean.reps2.com/tools/primary/${event.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.eventLink}
            key={0}
          >
            P&nbsp;
          </a>,
          <a
            href={`https://mrclean.reps2.com/tools/secondary/${event.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.eventLink}
            key={1}
          >
            S&nbsp;
          </a>,
          <a
            href={`https://mrclean.reps2.com/tools/venue/props/${event.venue.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.eventLink}
          >
            VP&nbsp;
          </a>,
          <a
            href={`https://mrclean.reps2.com/tools/venue/map/${event.venue.id}`}
            target="_blank"
            rel="noopener noreferrer"
            className={classes.eventLink}
          >
            VM
          </a>,
        ],
      };
    });
    return {
      rows: searchObject,
      currentPage: response.page,
      totalEvents: response.total_events,
    };
  });
};

export const fetchColumnPresets = () => dispatch => {
  Log.info('Redux Action -> fetchColumnPresets', true);
  dispatch(fetchColumnPresetsIsLoading(true));
  konamiApi
    .get(`${process.env.USER_API_URI}sets/2/keys`)
    .then(res => {
      Log.info('Redux Action -> fetchColumnPresets (res)', res);
      dispatch(fetchColumnPresetsIsLoading(false));
      dispatch(showColumnPresetOpButton(true));
      dispatch(columnPresetFetchSuccess(res.filters));
      dispatch(columnPresetLoadButtonVisible(!!Object.keys(res.filters).length));
      dispatch(reloadAllColumnPresets(false));
      dispatch(columnPresetDefaultButtonEnabledAction(true));
      // prettier-ignore
      const filteredDefaults = res.filters.filter(preset => preset.description.includes('default'));

      if (filteredDefaults.length) {
        const { value, id } = filteredDefaults[0];

        dispatch(handleColumnPresetOpSelectChange(id));
        dispatch(hiddenColumnNamesChange(value[0]));
        dispatch(columnOrderChange(value[1]));
        if (typeof value[2] === 'object') {
          // filter out what are the missing columns and added its default values.
          const responseColumnNames = value[2].map(column => column.columnName);
          const defaultColumnNames = defaultColumnWidths.map(column => column.columnName);
          const missingColumnNamesWidth = defaultColumnNames.filter(
            columnName => !responseColumnNames.includes(columnName)
          );
          const missingColumnsWithDefaultValues = missingColumnNamesWidth.map(columnName =>
            defaultColumnWidths.find(col => col.columnName === columnName)
          );

          dispatch(columnWidthChange([...value[2], ...missingColumnsWithDefaultValues]));
        }
        if (typeof value[3] === 'object') {
          dispatch(pinnedColumns(value[3]));
        }
        dispatch(columnPresetDefaultButtonEnabledAction(false));
      }
    })
    .catch(err => {
      Log.info('Redux Action -> fetchColumnPresets (err)', err);
      dispatch(fetchColumnPresetsIsLoading(false));
      dispatch(reloadAllColumnPresets(false));
    });
};

export const saveColumnPresets = () => (dispatch, getState) => {
  const { columnPresetName, columnPresets, columnOrder, columnWidths, leftColumns } = getState().eventSearch;
  Log.info('Redux Action -> saveColumnPresets (columnPresetName)', columnPresetName);

  dispatch(columnPresetSaveIsLoading(true));
  konamiApi
    .post(`${process.env.USER_API_URI}sets/2/keys`, {
      description: columnPresetName,
      value: [columnPresets, columnOrder, columnWidths, leftColumns],
    })
    .then(res => {
      Log.info('Redux Action -> saveColumnPresets (res)', res);
      dispatch(columnPresetSaveIsLoading(false));
      dispatch(handleSaveColumnPresets(false));
      dispatch(fetchColumnPresets());
      dispatch(showSaveColumnsButton(false));
    })
    .catch(err => {
      Log.info('Redux Action -> saveColumnPresets (err)', err);
      dispatch(columnPresetSaveIsLoading(false));
    });
};

export const defaultColumnChecked = () => (dispatch, getState) => {
  const { columnPresetName, savedColumnPresets, selectedColumnPreset } = getState().eventSearch;
  Log.info('Redux Action -> saveColumnPresets (columnPresetName)', columnPresetName);
  const currColumnPreset = savedColumnPresets.find(o => o.id === selectedColumnPreset);
  currColumnPreset.description.concat('- default');
  dispatch(columnPresetSaveIsLoading(true));
  konamiApi
    .put(`${process.env.USER_API_URI}keys/${currColumnPreset.id}`, {
      description: currColumnPreset.description.concat(' - default'),
      value: currColumnPreset.value,
    })
    .then(res => {
      Log.info('Redux Action -> saveColumnPresets (res)', res);
      dispatch(columnPresetSaveIsLoading(false));
      dispatch(handleSaveColumnPresets(false));
      dispatch(handleColumnPresetOpSelectChange(currColumnPreset.id));
      dispatch(fetchColumnPresets());
      dispatch(hiddenColumnNamesChange(currColumnPreset.value[0]));
    })
    .catch(err => {
      Log.info('Redux Action -> saveColumnPresets (err)', err);
      dispatch(columnPresetSaveIsLoading(false));
    });
};

export const defaultColumnRemoved = selectedPresetId => (dispatch, getState) => {
  const { columnPresetName, savedColumnPresets } = getState().eventSearch;
  Log.info('Redux Action -> saveColumnPresets (columnPresetName)', columnPresetName);
  const currColumnPreset = savedColumnPresets.find(o => o.id === selectedPresetId);
  dispatch(columnPresetSaveIsLoading(true));
  let arr = currColumnPreset.value;
  arr = arr.filter(e => e !== 'default');
  const desc = currColumnPreset.description.replace(' - default', '');
  konamiApi
    .put(`${process.env.USER_API_URI}keys/${currColumnPreset.id}`, {
      description: desc,
      value: arr,
    })
    .then(res => {
      Log.info('Redux Action -> saveColumnPresets (res)', res);
      dispatch(columnPresetSaveIsLoading(false));
      dispatch(handleSaveColumnPresets(false));
      dispatch(handleColumnPresetOpSelectChange(currColumnPreset.id));
      dispatch(fetchColumnPresets());
      dispatch(hiddenColumnNamesChange(currColumnPreset.value[0]));
    })
    .catch(err => {
      Log.info('Redux Action -> saveColumnPresets (err)', err);
      dispatch(columnPresetSaveIsLoading(false));
    });
};

export const deleteColumnPresets = selectedPresetId => (dispatch, getState) => {
  const { savedColumnPresets } = getState().eventSearch;
  Log.info(`${CURRENT_CONTEXT} (savedColumnPresets)`, savedColumnPresets);
  Log.info('Redux Action -> columnPresetDeleteSubmitClicked (selectedColumnPreset)', selectedPresetId);
  dispatch(fetchPresetFiltersIsLoading(true));
  konamiApi
    .delete(`${process.env.USER_API_URI}keys/${selectedPresetId}`)
    .then(res => {
      Log.info('Redux Action -> saveColumnPresets (res)', res);
      dispatch(handleDeleteColumnPresets(false));
      dispatch(handleLoadColumnPresets(false));
      dispatch(handleColumnPresetOpSelectChange(-1));
      dispatch(fetchColumnPresets());
    })
    .catch(err => {
      Log.info('Redux Action -> saveColumnPresets (err)', err);
      alert('Sorry chief theres no deleting this one');
    });
};

/**
 * generateLimitSheet2: Generate limitsheet with the token inside
 * and the selected rows from ag grid
 * @memberof event-search
 */
export const generateLimitSheet2 = () => (dispatch, getState) => {
  const { selectedRows, whosNames } = getState().eventSearch;
  const eventIds = selectedRows.map(event => parseInt(event.data.event_id, 0));
  const bodyFormData = new FormData();
  bodyFormData.append('event_ids', eventIds);
  bodyFormData.append('broker', whosNames);
  Log.info('Redux Action -> handleLimitSheetGen (selectedEvents)', selectedRows);
  dispatch(handlePullNowPostInProgress(true));
  dispatch(infoSnackbarIsOpen(true));

  konamiApi
    .post(`limitsheets/`, bodyFormData)
    .then(response => {
      Log.info(response);
      dispatch(limitsheetIsLoading(false));
      dispatch(limsheetUrl(response.data.url));
      dispatch(limsheetTitle(response.data.name));
      dispatch(limsheetSuccessOpen(true));
      dispatch(limsheetSuccessOpen(false));
      dispatch(infoSnackbarIsOpen(false));
      Log.info(`${CURRENT_CONTEXT} limsheet`, limsheetSuccessOpen);
    })
    .catch(err => {
      Log.info('Redux Action -> gen limsheet (err)', err);
      alert('You just got rate limited generating a limitsheet. try again later!');
    });
  dispatch(handlePullNowPostInProgress(false));
};

/**
 * agGridRowsSelected: Save the selected rows from ag grid
 * @param {object[]} selectedRows Array of the selected rows on ag grid
 * @memberof event-search
 */
export const agGridRowsSelected = selectedRows => ({
  type: EVENT_SEARCH_ROW_SELECTED,
  payload: selectedRows,
});

/**
 * pullSelectedEvents2: Trigger the pull method to update the selected events
 * with the selected rows from ag grid
 * @memberof event-search
 */
export const pullSelectedEvents2 = () => (dispatch, getState) => {
  const { selectedRows } = getState().eventSearch;
  Log.info('Redux Action -> handlePullNowClicked (selectedRows)', selectedRows);
  dispatch(handlePullNowPostInProgress(true));

  axios.all(selectedRows.map(event => konamiApi.post(`event/pull/${event.data.event_id}`))).then(responses => {
    responses.forEach(response => {
      Log.info(response);
    });
    dispatch(handlePullNowPostInProgress(false));
  });
};

/**
 * checkSelectedEvents2: Trigger the checked method to update the selected events
 * with the selected rows from ag grid
 * @memberof event-search
 */
export const checkSelectedEvents2 = () => (dispatch, getState) => {
  const { selectedRows } = getState().eventSearch;
  Log.info('Redux Action -> handlePullNowClicked (selectedRows)', selectedRows);
  dispatch(handlePullNowPostInProgress(true));

  axios
    .all(
      selectedRows.map(event =>
        konamiApi.post(`user/ext_event_attr/${event.data.event_id}`, {
          checked_time: moment.utc(new Date()).format('YYYY-MM-DD HH:mm:ss'),
        })
      )
    )
    .then(responses => {
      responses.forEach(response => {
        Log.info(response);
      });
      dispatch(handlePullNowPostInProgress(false));
    });
};
